import { inject, Service } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { getActiveLanguage } from '@utils/translate';

@Service({ autoProvided: false })
export class LanguageInterceptor implements HttpInterceptor {
  private translateService = inject(TranslateService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const currentlang = getActiveLanguage(this.translateService);
    if (currentlang) {
      const modifiedReq = request.clone({
        headers: request.headers.set('Accept-Language', currentlang)
      });
      return next.handle(modifiedReq);
    }
    return next.handle(request);
  }
}
